import { ISpeedMessage } from '@Encore-FastStartup-Phase-Out/encore-shared';

import { endpoints } from '../constants/endpoints';
import { ChatQueryDto, SpeedMessageDto } from '../constants/types';

import { BaseApi } from './index';

export class SpeedMessageApi extends BaseApi<any> {
  constructor() {
    super(endpoints.speedMessages.base);
  }

  async getSpeedMessages(query?: Partial<ChatQueryDto>) {
    return this.fetch(endpoints.speedMessages.base, { params: query });
  }

  async deleteSpeedMessage(id: string) {
    return this.delete(endpoints.speedMessages.byId(id));
  }

  async updateSpeedMessage(id: string, speedMessage: SpeedMessageDto) {
    return this.patch(endpoints.speedMessages.byId(id), speedMessage);
  }

  async createSpeedMessage(speedMessage: SpeedMessageDto): Promise<ISpeedMessage> {
    return this.post(endpoints.speedMessages.base, speedMessage);
  }
}
